import { render, staticRenderFns } from "./AccountAssetFormVehicle.vue?vue&type=template&id=2cb783ab&scoped=true&"
import script from "./AccountAssetFormVehicle.vue?vue&type=script&lang=ts&"
export * from "./AccountAssetFormVehicle.vue?vue&type=script&lang=ts&"
import style0 from "./AccountAssetFormVehicle.vue?vue&type=style&index=0&id=2cb783ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb783ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
